import { motion } from "framer-motion";

const IMG_MAIN = "https://images.pexels.com/photos/34921744/pexels-photo-34921744.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_ALT = "https://images.unsplash.com/photo-1762635696772-0ed637b1a3a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwbW9kZWwlMjBkYXJrJTIwZmFzaGlvbnxlbnwwfHx8fDE3ODc2NDc1OTV8MA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  return (
    <section id="nosotros" className="relative py-32 px-6 overflow-hidden" data-testid="about-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-20 items-center">
        <div className="relative">
          <motion.div
            initial={{ opacity: 0, x: -48 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="relative z-10 w-4/5 aspect-[3/4] overflow-hidden border border-white/10"
          >
            <img src={IMG_MAIN} alt="Elegancia Maison Élixir" loading="lazy" className="w-full h-full object-cover" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 48, y: 48 }}
            whileInView={{ opacity: 1, x: 0, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="absolute -bottom-12 right-0 w-1/2 aspect-square overflow-hidden border border-gold/30"
          >
            <img src={IMG_ALT} alt="Detalle de perfume" loading="lazy" className="w-full h-full object-cover" />
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.15, ease: "easeOut" }}
          className="lg:pl-8 pt-16 lg:pt-0"
        >
          <span className="font-script-lux text-gold text-3xl">Sobre nosotros</span>
          <h2 className="font-serif-lux text-4xl sm:text-5xl tracking-[0.15em] uppercase text-white mt-4 leading-tight">
            Una maison<br />con alma
          </h2>
          <div className="w-16 h-px bg-gold mt-8 mb-8" />
          <p className="text-neutral-400 font-light leading-relaxed">
            Maison Élixir nace de una convicción sencilla: un perfume no se lleva, se habita. Cada creación de nuestra colección está pensada para acompañarte y convertirse en parte de tu historia.
          </p>
          <p className="text-neutral-400 font-light leading-relaxed mt-5">
            Creemos en el trato cercano. Por eso entregamos cada pedido personalmente a domicilio y pagas al recibirlo. Sin tarjetas, sin intermediarios: solo tú y tu esencia.
          </p>
          <p className="font-script-lux text-gold text-4xl mt-12">Maison Élixir</p>
          <p className="text-[10px] uppercase tracking-[0.4em] text-neutral-500 mt-2">Parfums d'Exception</p>
        </motion.div>
      </div>
    </section>
  );
};
